import { ErrorConfiguration } from "#/models/error-configuration";
import { create } from "zustand";

type ErrorConfigurationStoreType = {
  errorConfiguration?: ErrorConfiguration;
  setErrorConfiguration: (configuration: ErrorConfiguration) => void;
};

const useErrorConfigurationStore = create<ErrorConfigurationStoreType>(
  (set) => ({
    errorConfiguration: undefined,
    setErrorConfiguration: (configuration: ErrorConfiguration) =>
      set({ errorConfiguration: configuration }),
  })
);

export default useErrorConfigurationStore;
